import React from 'react';
import { ArrowRight, Sparkles } from 'lucide-react';

const Hero = () => {
  return (
    <section style={{
      minHeight: '100vh',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      position: 'relative',
      overflow: 'hidden',
      background: 'radial-gradient(ellipse at top, rgba(212, 175, 55, 0.1) 0%, transparent 60%)'
    }}>
      {/* Decorative elements */}
      <div style={{
        position: 'absolute',
        top: '20%',
        right: '10%',
        width: '300px',
        height: '300px',
        background: 'radial-gradient(circle, rgba(212, 175, 55, 0.15) 0%, transparent 70%)',
        borderRadius: '50%',
        filter: 'blur(80px)'
      }} />

      <div style={{
        maxWidth: '1400px',
        margin: '0 auto',
        padding: '0 40px',
        textAlign: 'center',
        position: 'relative',
        zIndex: 1
      }}>
        <div className="fade-in" style={{ transitionDelay: '0.2s' }}>
          <div style={{
            display: 'inline-flex',
            alignItems: 'center',
            gap: '10px',
            background: 'rgba(212, 175, 55, 0.1)',
            border: '1px solid rgba(212, 175, 55, 0.3)',
            borderRadius: '50px',
            padding: '10px 25px',
            marginBottom: '30px'
          }}>
            <Sparkles size={18} color="#D4AF37" />
            <span style={{
              fontFamily: 'Montserrat, sans-serif',
              fontSize: '14px',
              fontWeight: '500',
              color: '#D4AF37',
              letterSpacing: '1px'
            }}>
              Chegou Sua Hora de Brilhar...
            </span>
          </div>
        </div>

        <h1 className="fade-in" style={{
          fontFamily: 'Playfair Display, serif',
          fontSize: '72px',
          fontWeight: '800',
          lineHeight: '1.1',
          marginBottom: '30px',
          transitionDelay: '0.4s'
        }}>
          Sites Que <span className="gold-gradient">Convertem</span><br />
          Visitantes em <span className="gold-gradient">Clientes</span>
        </h1>

        <p className="fade-in" style={{
          fontFamily: 'Montserrat, sans-serif',
          fontSize: '20px',
          fontWeight: '300',
          color: '#CCCCCC',
          maxWidth: '800px',
          margin: '0 auto 50px',
          lineHeight: '1.8',
          transitionDelay: '0.6s'
        }}>
          Transforme sua presença digital com sites profissionais que não apenas impressionam,
          mas <strong style={{ color: '#D4AF37', fontWeight: '600' }}>geram resultados reais</strong> para o seu negócio.
          Desenvolvimento exclusivo com tecnologia de ponta.
        </p>

        <div className="fade-in" style={{
          display: 'flex',
          gap: '20px',
          justifyContent: 'center',
          flexWrap: 'wrap',
          transitionDelay: '0.8s'
        }}>
          <button
            onClick={() => window.open('https://wa.me/5562995664918?text=Olá! Gostaria de solicitar um orçamento para meu projeto.', '_blank')}
            className="btn-primary shimmer"
            style={{
              display: 'inline-flex',
              alignItems: 'center',
              gap: '10px',
              fontSize: '18px'
            }}
          >
            SOLICITAR ORÇAMENTO
            <ArrowRight size={20} />
          </button>
          <button
            onClick={() => document.getElementById('portfolio')?.scrollIntoView({ behavior: 'smooth' })}
            className="btn-secondary"
            style={{ fontSize: '18px' }}
          >
            VER PORTFÓLIO
          </button>
        </div>

        {/* Stats */}
        <div className="fade-in" style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))',
          gap: '40px',
          marginTop: '100px',
          padding: '50px 0',
          borderTop: '1px solid rgba(212, 175, 55, 0.2)',
          borderBottom: '1px solid rgba(212, 175, 55, 0.2)',
          transitionDelay: '1s'
        }}>
          {[
            { value: '100%', label: 'Taxa de Satisfação' },
            { value: '48h', label: 'Tempo Médio de Entrega' },
            { value: '24/7', label: 'Suporte Técnico' }
          ].map((stat, idx) => (
            <div key={idx}>
              <div style={{
                fontFamily: 'Playfair Display, serif',
                fontSize: '48px',
                fontWeight: '700',
                color: '#D4AF37',
                marginBottom: '10px'
              }}>
                {stat.value}
              </div>
              <div style={{
                fontFamily: 'Montserrat, sans-serif',
                fontSize: '14px',
                fontWeight: '500',
                color: '#CCCCCC',
                textTransform: 'uppercase',
                letterSpacing: '1px'
              }}>
                {stat.label}
              </div>
            </div>
          ))}
        </div>
      </div>

      <style>{`
        @media (max-width: 768px) {
          h1 {
            font-size: 42px !important;
          }
        }
      `}</style>
    </section>
  );
};

export default Hero;